module.exports = __webpack_public_path__ + "static/media/failure_2.06655070.gif";